<div class="signup-otp-verify-container">
  <ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '14px' }"></ngx-loading>


  <div class="signup-Second-step">
    <h3 class="heading">Check your email!</h3>
    <div class="otp-sent-section">
      <div>
        <span>Enter the 4 - digit code sent to <br /><b>{{ emailId }}</b></span>
      </div>
      <div class="otp-input-section">
        <form [formGroup]="verifyOtpFormGroup">
          <input type="number" class="InputFields" #inp1 id="inp1" formControlName="inp1" (input)="onInput($event)" (keydown)="onKeydown($event)">
          <input type="number" class="InputFields" #inp2 id="inp2" formControlName="inp2" (input)="onInput($event)" (keydown)="onKeydown($event)">
          <input type="number" class="InputFields" #inp3 id="inp3" formControlName="inp3" (input)="onInput($event)" (keydown)="onKeydown($event)">
          <input type="number" class="InputFields" #inp4 id="inp4" formControlName="inp4" (input)="onInput($event)" (keydown)="onKeydown($event)">
        </form>
        <div>
          <p>Time Remaining <span> {{ displayTime }}</span></p>
        </div>
        @if (otpVerifyErrorFlag === true) {
          <div>
            <p class="otp-invalid-error">The OTP you entered is invalid. Please enter the correct OTP!</p>
          </div>
        }
      </div>
      @if (otpVerifyErrorMsg) {
        <div>
          <p class="otp-invalid-error">{{ otpVerifyErrorMsg }}</p>
        </div>
      }
      <div class="userNote">
        <p>
          If the email is incorrect, please close this window and update your details.
        </p>
      </div>
      <div>
        @if (isResendAllowed) {
          <div class="resend-code">
            Did not received yet? &nbsp;<a (click)="onResendCodeClick()">Resend Code</a>
          </div>
        }
        @if (!isResendAllowed) {
          <div class="resend-code-msg">
            OTP has been sent to your email. Please wait for the code to arrive.
          </div>
        }
      </div>
      <div class="action-btn-wrapper">
        <button class="btn secondary-btn" (click)="onCloseBtnClick()">Close</button>
        <button class="btn primary-btn" #verifyBtn (click)="onVerifyBtnClick()" [disabled]="!verifyOtpFormGroup.valid">Verify</button>
      </div>
    </div>
  </div>
</div>